import { Component } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import {
  DialogBodyComponent,
  DialogComponentI,
  DialogHeaderComponent,
  DialogRef,
  NewItemButtonComponent,
} from '@recruitee/user-interface';

type DialogData = {
  jobsCount: number;
};
type DialogResult = {
  enable: boolean;
};

@Component({
  selector: 'rt-manage-referrals-dialog',
  templateUrl: './manage-referrals-dialog.component.html',
  styleUrls: ['./manage-referrals-dialog.component.less'],
  standalone: true,
  imports: [DialogHeaderComponent, DialogBodyComponent, NewItemButtonComponent, TranslatePipe],
})
export class ManageReferralsDialogComponent implements DialogComponentI<DialogData, DialogResult> {
  public jobsCount = 0;
  constructor(private dialogRef: DialogRef) {}

  public enable() {
    this.dialogRef.close({ enable: true });
  }

  public disable() {
    this.dialogRef.close({ enable: false });
  }

  public setDialogData(data: DialogData, triggerUpdate: boolean): void {
    this.jobsCount = data.jobsCount || 1;
  }
}
